import { render, staticRenderFns } from "./StripeOnboardingModal.vue?vue&type=template&id=b1e4e98c&scoped=true"
import script from "./StripeOnboardingModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./StripeOnboardingModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StripeOnboardingModal.vue?vue&type=style&index=0&id=b1e4e98c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e4e98c",
  null
  
)

export default component.exports